const composeGapProperty = (values: Record<string, string | null>): string => {
  const { rowGap, columnGap } = values;

  if (!rowGap && !columnGap) {
    return '';
  }

  // If both values are the same, use shorthand
  if (rowGap && columnGap && rowGap === columnGap) {
    return rowGap;
  }

  // If only one value is present, use it as the single value
  if (rowGap && !columnGap) {
    return rowGap;
  }

  if (!rowGap && columnGap) {
    return columnGap;
  }

  // Both values are different, use the two-value syntax
  return `${rowGap} ${columnGap}`;
};

const composePaddingProperty = (
  values: Record<string, string | null>,
): string => {
  const { paddingTop, paddingRight, paddingBottom, paddingLeft } = values;

  if (!paddingTop && !paddingRight && !paddingBottom && !paddingLeft) {
    return '';
  }

  const top = paddingTop || '';
  const right = paddingRight || '';
  const bottom = paddingBottom || '';
  const left = paddingLeft || '';

  // All sides are the same
  if (top === right && right === bottom && bottom === left) {
    return top;
  }

  // Top/bottom same, left/right same
  if (top === bottom && right === left) {
    return `${top} ${right}`;
  }

  // Left and right same
  if (right === left) {
    return `${top} ${right} ${bottom}`;
  }

  // All different
  return `${top} ${right} ${bottom} ${left}`;
};

export const spacingComposeMap = {
  gap: composeGapProperty,
  padding: composePaddingProperty,
};
